// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src560599644/src/~/core-js/library/modules/_defined.js
// module id = sovd
// module chunks = 6